import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export enum PanoramaEventNames {
  AddSessionToCart = 'add-session-to-cart',
  NavigateToCheckout = 'navigate-to-checkout',
}

export interface PanoramaLogger {
  transactionStarted(eventName: PanoramaEventNames): void;
  transactionEnded(eventName: PanoramaEventNames): void;
}

export function createPanoramaLogger(
  flowApi: ControllerFlowAPI,
): PanoramaLogger {
  return {
    transactionStarted: (name: PanoramaEventNames) =>
      flowApi?.panoramaClient?.transaction(name).start(),
    transactionEnded: (name: PanoramaEventNames) =>
      flowApi?.panoramaClient?.transaction(name).finish(),
  };
}
